"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../Button/Button");

require("./NavButton.css");

var _Icon = _interopRequireDefault(require("../../Graphics/Icon/Icon"));

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

var _excluded = ["color", "type", "action", "onClick", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @visibleName Navigation Button
 */
function NavButton(_ref) {
  var color = _ref.color,
      type = _ref.type,
      action = _ref.action,
      onClick = _ref.onClick,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var classNames = 'btn btn-fill nav-btn ';

  if (className) {
    classNames += className;
  }

  var iconColor = '#fff';

  if (color === 'secondary' || action === 'close') {
    classNames += ' secondary';
    iconColor = _Colors.default.sinineVaal;
  }

  if (action === 'close') {
    return /*#__PURE__*/_react.default.createElement("button", _extends({
      type: type,
      className: classNames,
      onClick: onClick
    }, rest), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "times",
      color: iconColor
    }));
  } else {
    return /*#__PURE__*/_react.default.createElement("button", _extends({
      type: type,
      className: classNames.concat(' rotate-icon'),
      onClick: onClick
    }, rest), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "arrowUpRight",
      color: iconColor
    }));
  }
}

NavButton.propTypes = {
  /** The type of the button */
  type: _propTypes.default.oneOf(['button', 'reset', 'submit']),

  /** The color of the button */
  color: _propTypes.default.oneOf(['primary', 'secondary']),

  /** The icon on the button */
  action: _propTypes.default.oneOf(['back', 'close']),

  /** Gets called when the user clicks on the button */
  onClick: _propTypes.default.func
};
NavButton.defaultProps = {
  type: 'button',
  color: 'primary',
  action: 'back',
  onClick: function onClick(event) {
    // eslint-disable-next-line no-console
    console.log('You have clicked me!', event.target);
  }
};
var _default = NavButton;
exports.default = _default;